var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_9606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_9606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.285645V25.2856H23.5V0.285645H0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_9606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.186 2.28564C18.594 2.28564 19.9485 2.84509 20.9449 3.84892C21.9424 4.85064 22.5 6.20176 22.5 7.6162V15.9551C22.5 18.9001 20.1165 21.2856 17.186 21.2856H6.813C3.88245 21.2856 1.5 18.9001 1.5 15.9551V7.6162C1.5 4.6712 3.87195 2.28564 6.813 2.28564H17.186ZM18.2328 8.71461L18.3157 8.62937C18.5633 8.32037 18.5633 7.87286 18.3043 7.56386C18.1603 7.4051 17.9624 7.30814 17.7562 7.28683C17.5386 7.27511 17.3314 7.35076 17.175 7.49993L12.5033 11.3358C11.9023 11.8483 11.0413 11.8483 10.4311 11.3358L5.76872 7.49993C5.4465 7.25486 5.00099 7.28683 4.73264 7.57452C4.4529 7.8622 4.42182 8.32037 4.65908 8.64002L4.79481 8.77854L9.50898 12.5611C10.0892 13.0299 10.7927 13.2856 11.5293 13.2856C12.2639 13.2856 12.9799 13.0299 13.559 12.5611L18.2328 8.71461Z",
    fill: "#FFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_9606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 25,
    fill: "white",
    transform: "translate(0.5 0.285645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.61a65a63cd59f63dfb87b43c1e3a08d2.svg";
export { ForwardRef as ReactComponent };